import React from 'react';

import Grid from '@material-ui/core/Grid';

import { LineChart, Line, Tooltip, XAxis, YAxis } from 'recharts';

class LineChartComponent extends React.Component {

    render() {

        return (
            <Grid container direction="row"
                justifyContent="center" alignItems="center">
                <LineChart width={950} height={500} data={this.props.data}>
                    <XAxis angle={-5} dataKey="Time" />
                    <YAxis type="number" domain={['dataMin - 1.21', 'dataMax']} />
                    <Tooltip />
                    <Line type="monotone" dataKey="Value" stroke="#8884d8" dot={false} />
                </LineChart>
            </Grid>
        )
    }
}

export default LineChartComponent;